import {CalendarSlotStatus, JarvisStatus, VehicleType} from "shared/constants";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { IDocument } from "./contract";

export enum CalendarDayServiceType {
    TRUCK_LOADING = 0,
    COOL_DOWN_TL = 1,
    GAS_UP_COOL_DOWN_TL = 2,
    SEMI_TRAILER_APPROVAL_TL = 3,
    DRIVER_APPROVAL_TL = 4,
    SEMI_TRAILER_DRIVER_APPROVAL_TL = 5,
    ISO_CONTAINER_APPROVAL_TL = 6,
    ISO_CONTAINER_DRIVER_APPROVAL_TL = 7,
}

export interface ICalendarDayService extends Record<string, string|number|boolean>{
    service: number, //identificativo del servizio secodno l’enumeratore sopra
    startTime: string, //"00:00"
    endTime: string, //"00:00"
    available:boolean
}

//Single calendar config day
export interface ICalendarDay extends Record<string, number|string|ICalendarDayService[]>{
    dayOfWeek: number, // (0-LUN, ecc)
    startTime: string, //"00:00"
    endTime: string, //"00:00"
    services: ICalendarDayService[]
}

export interface ICalendarExtendedPropReservationDetail {
    label: string,
    status: CalendarSlotStatus

}
export interface ICalendarExtendedProp{
    tooltip:string,
    services:number[],
    baysAvailable:string[],
    slotsAvailable:number,
    slotStatus:CalendarSlotStatus,
    reservations: ICalendarExtendedPropReservationDetail[]
}
//Calendar event for slots
export interface ICalendarEvent{
    id:string,
    title:string,
    start:string,
    end:string,
    classNames:string[],
    extendedProps?: ICalendarExtendedProp 
}

export interface ICalendarDialogFormData {
    type?:number,
    startDate?:number,
    endDate?:number,
    temp?:string,
    startTime?:string,
    endTime?:string,
    bayes?:IBayes[],
    slotId?:string,
    service?:number,
    clientId?:string,
    contractId?:string,
    days?:boolean[],
    maintainReservations?:boolean,
    bioFlagStatus?:boolean
}

export interface ICalendarDialogForm {
    getFormValues: () => ICalendarDialogFormData; 
}

export interface IBayes {
    id:string,
    bayName:string,
    unavailable:boolean
}
export interface IUnvailableBayes {
    startDate:number,
    endDate:number,
    startTime:string,
    endTime:string,
    bayes:IBayes[]
}
export interface IContractServicesBookSlot {
    contractId:string,
    services:Number[]
}
export interface IContractBookSlot extends ISelectLabel{
    available?: boolean,
    contracts?: IContractBookSlot[]
    contractServices?: IContractServicesBookSlot[],
    bioFlagDisabled?: boolean,
    bioFlagStatus?: boolean
}

export interface IBookingAddress {
    destinationAddress: string, 
    destinationNation: string 
    destinationStreetNumber:string, 
    destinationPostalCode:string, 
    destinationCity:string, 
    destinationProvince:string,
    destinationBusinessName:string, //new
    destinationVat:string, //new
}
export interface IBooking{
    codeIup: string,
    reservationCode:string,
    date: number, //timestamp del giorno dello slot
    time: string, //stringa nel formato "HH:mm-HH:mm" inizio-fine slot
    status: CalendarSlotStatus, //secondo enumeratore calendar status
   
    jarvisAvailable: JarvisStatus, //da usare solo nel dettaglio di inserimento
    jarvisShipper: JarvisStatus,
    jarvisAck?: boolean,
   
    typeVehicle: VehicleType, //1 per autobotte 2 iso-container (enumeratore veicoli)
    truckTractor: string, //id a db del trattore
    tankerTruck: string,
    isoContainer: string,
    flatBed: string,
   
    driverId: string, // id del driver selezionato
    forcedBay:string,
    bay: string, //non necessaria in fase di inserimento
    bayLoadingSide?:string, //lato di caricamento della bay "" baia non assegnata, "0" destra, "1" sinistra
    bayAssignmentAttemptSuccess:boolean|null, //null non è passata, true è passata e ha assegnato, false è passata ma non ha assegnato

    destinationAddress: string, //destinazione da raggiungere
    destinationNation: string //nazione della destinazione
    destinationStreetNumber:string, //new
    destinationPostalCode:string, //new
    destinationCity:string, //new
    destinationProvince:string, //new
    destinationBusinessName:string, //new
    destinationVat:string, //new

    lastMinute: boolean,

    secondaryDestination : IBookingAddress[], //nuovo oggetto per le seconda destinazione

    crossedNation: string[] 
   
    destinationTime: string, //stringa con formato HH:mm
   
    businessName: string, //nome del cliente
    service: CalendarDayServiceType, //identificativo del servizio
 
    shipperId:string, //id fornitore
    shipperName:string, //nome fornitore

    transporterId:string,
    transporterName:string,
   
    longTermTimeStamp:number, //timestamp che indica la data in cui scade il long term
    freezingTimeStamp:number, //timestamp che indica la data in cui scade il long term
    salesFreezingTimeStamp:number, //timestamp freezing date commerciale
    supplyingResultId: number,
    supplyingResultNote:string,
    //-- dati dal T-MAC
    closedLoadMass: number | null, //DATI CHIUSURA quantità caricata massa -- valorizzato in futuro -- se BE è null valorizzato con -1
    closedLoadEnergy: number | null, //DATI CHIUSURA quantità caricata energia -- valorizzato in futuro -- se BE è null valorizzato con -1
    closedDensity: number | null,
    closedStandardDensity: number | null,
    closedNormalConditionDensity: number | null,
    closedExpansionFactor: number | null,
    closedHeatCombustionMass: number | null,
    closedHeatCombustionVolume: number | null,
   
    loadingCertificate?: IDocument, //oggetto di tipo document -- NULL se non disponibile (DA CONFERMARE)codeIup: ""
 
    transporterDeleted : boolean,
    truckTractorDeleted : boolean,
    tankerTruckDeleted : boolean,
    flatBedDeleted : boolean,
    isoContainerDeleted : boolean,
    driverDeleted : boolean,

    truckTractorPlate : string | null,
    tankerTruckPlate : string | null,
    flatBedPlate : string | null,
    isoContainerCode : string | null,
    driverFirstName : string | null,
    driverLastName : string | null,

    preventiveQuantity: number | null,
    preventiveEnergy: number | null,

    shipperMediatorName?: string  | null,
    accessCode?: number |null,

    coolDownTmacWAavailable?:boolean | null,
    coolDownTmacWAchecked?: boolean | null,

    shipperAggrShipper: JarvisStatus,
    shipperAggrAvailable: JarvisStatus,

    dailyGasPrice?: number | null,
    finalBusiness: string | null | undefined,
    insertUserName: string | null,

    bioFlagStatus?:boolean,
    bioFlagDisabled?:boolean,
    percentageBioLng?:number
}

export interface ICloneReservation {
    codeIup:string,
    newDate:string,
    newTime:string
}

export interface IReportElement {
    codeIup:string,
    reservationCode:string,
    clientId:string, 
    contractId:string, 
    businessName:string,
    contractCode:string,
    date:string, 
    time:string, 
    service:number,
    cost:number,
    shipperId:string,
    shipperName:string,
    supplyingResultId:number,
    energy:number,
    mass:number,
    reservationStatusId:string
    dailyGasPrice?: number | null,
    percentageBioLng?: number,
    fossil?:number,
    bioLngQuantity?:number,
    bioFlagDisabled?: boolean
}


export interface ICheckListData extends Record<string,string|boolean|null> {
    "codeIup": string,
    "codeIupCorrispondence":boolean|null , //NUMBER {1=Yes;2=NO,3=Non compilato}
    "identityDocValue": string, 
    "identityDocCorrispondence": boolean|null,
    "driverLicenceValue": string,
    "driverLicenceCorrispondence": boolean|null,
    "licencePlateTruckTractorValue": string,
	"licencePlateTruckTractorCorrispondence": boolean|null,
    "licencePlateTankerTruckValue": string,
	"licencePlateTankerTruckCorrispondence": boolean|null,
    "licencePlateIsoContainerValue": string,
	"licencePlateIsoContainerCorrispondence": boolean|null, 
    "licencePlateFlatBedValue": string, 
	"licencePlateFlatBedCorrispondence": boolean|null,
    "vehicleConditionValue": boolean|null,
    "vehicleConditionNotes": string,
    "instructionsDocumentValue": boolean|null, //NEW
    "instructionsDocumentNotes": string, //NEW
  	"orangeLicencePlateValue": boolean|null, 
    "orangeLicencePlateNotes": string,
    "loadWedgesValue": boolean|null, 
    "loadWedgesNotes": string, 
    "fireExtinguisherValue": boolean|null,
    "fireExtinguisherNotes": string,
    "atexValue": boolean|null,
    "atexNotes": string,
    "gnlValue": boolean|null,
    "gnlNotes": string,
	"insulationFailureValue": boolean|null,
    "insulationFailureNotes": string,
    "dpIpresenceValue": boolean|null,
    "dpIpresenceNotes": string,
    "sealsPresenceValue": boolean|null,
    "sealsPresenceNotes": string,
    "kitPresenceValue":boolean|null, //NEW
    "kitPresenceNotes":string, //NEW
    "boardingValue": boolean|null,
    "boardingNotes": string,
    "lastUpdateTimestamp": string|null, //NEW
}

export interface IBillingReport {
    startDate:string,
    endDate:string,
    businessId:string,
    contractId:string
}